import { ContainerLengthBayMappingDto } from '@yard/app/api/dg-config-api'
import { ContainerLengthBayMappingFormProfile, defaultValues } from './container-length-bay-mapping-form.profile'

export const mapDtoToFormProfile = (
  dto?: ContainerLengthBayMappingDto,
): ContainerLengthBayMappingFormProfile => {
  if (!dto) return defaultValues

  return {
    id: dto.id,
    length: dto.length,
    bayCount: dto.bayCount,
    isStandard: dto.isStandard,
  }
}
